<template>
  <div class="scroll-container">
    <div class="seachBox flex">
      <a-button
        class="top_btn"
        type="primary"
        @click="
          () => {
            openAddModal();
          }
        "
      >
        添加图标
      </a-button>

      <div class="flex">
        <div class="seachList" style="width: 220px;">
          <a-input
            placeholder="请输入查询的图标名称"
            class="seachs"
            v-model="seach.name"
            style="width: 100%;"
          />
        </div>
        <div class="seachBtnBox" style="width: 180px; position: relative;">
          <a-button
            type="primary"
            size="default"
            class="seachBtn"
            @click="getList(1)"
          >
            查询
          </a-button>
          <a-button size="default" class="seachBtn" @click="resetSeach()"
            >重置</a-button
          >
        </div>
      </div>
    </div>
    <a-table
      :columns="columns"
      :data-source="data"
      :loading="loading"
      rowKey="id"
      :pagination="pagination"
    >
      <span slot="type" slot-scope="text, record">
        {{ record.type == 1 ? "IconFont图标" : "彩色图标" }}
      </span>
      <span slot="action" slot-scope="text, record">
        <a
          @click="
            (record) => {
              visiblebj = true;
              editId = text.id;
              getEditData();
            }
          "
          >编辑<a-divider type="vertical"
        /></a>
        <a-popconfirm
          title="此操作将永久删除, 是否继续?"
          ok-text="确定"
          cancel-text="取消"
          @confirm="confirm(record)"
          @cancel="() => {}"
        >
          <a>删除</a>
        </a-popconfirm>
      </span>
    </a-table>
    <a-drawer
      :title="drawerTitle"
      placement="right"
      :visible="visiblebj"
      @close="onClose"
      :width="600"
      :destroyOnClose="true"
      :body-style="{ paddingBottom: '80px' }"
    >
      <a-form-model
        ref="ruleform"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item
          ref="name"
          label="图标名称"
          prop="name"
          :help="formErr.name"
          :validateStatus="!formErr.name || formErr.name == '' ? '' : 'error'"
        >
          <a-input
            v-model="form.name"
            @change="
              (e) => {
                formErr.name = '';
              }
            "
            :maxLength="20"
            @blur="
              (e) => {
                form.name = e.target.value.trim();
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item
          ref="type"
          label="图标类型"
          prop="type"
          :help="formErr.type"
          :validateStatus="!formErr.type || formErr.type == '' ? '' : 'error'"
        >
          <a-select v-model="form.type">
            <a-select-option
              :key="item.value"
              :value="item.value"
              v-for="item in typeList"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          ref="a_icon_library_category_id"
          label="所属分类"
          prop="a_icon_library_category_id"
          :help="formErr.a_icon_library_category_id"
          :validateStatus="
            !formErr.a_icon_library_category_id ||
            formErr.a_icon_library_category_id == ''
              ? ''
              : 'error'
          "
        >
          <a-select v-model="form.a_icon_library_category_id">
            <a-select-option
              :key="item.id"
              :value="item.id"
              v-for="item in icon_library_category"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          ref="font_class"
          label="font_class"
          prop="font_class"
          :help="formErr.font_class"
          :validateStatus="
            !formErr.font_class || formErr.font_class == '' ? '' : 'error'
          "
        >
          <a-input
            v-model="form.font_class"
            @change="
              (e) => {
                formErr.font_class = '';
              }
            "
            :maxLength="50"
            @blur="
              (e) => {
                form.font_class = e.target.value.trim();
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item
          ref="unicode"
          label="unicode"
          prop="unicode"
          :help="formErr.unicode"
          :validateStatus="
            !formErr.unicode || formErr.unicode == '' ? '' : 'error'
          "
        >
          <a-input
            v-model="form.unicode"
            @change="
              (e) => {
                formErr.unicode = '';
              }
            "
            :maxLength="20"
            @blur="
              (e) => {
                form.unicode = e.target.value.trim();
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item
          ref="unicode_decimal"
          label="unicode_decimal"
          prop="unicode_decimal"
          :help="formErr.unicode_decimal"
          :validateStatus="
            !formErr.unicode_decimal || formErr.unicode_decimal == ''
              ? ''
              : 'error'
          "
        >
          <a-input
            v-model="form.unicode_decimal"
            @change="
              (e) => {
                formErr.unicode_decimal = '';
              }
            "
            :maxLength="20"
            @blur="
              (e) => {
                form.unicode_decimal = e.target.value.trim();
              }
            "
          />
        </a-form-model-item>
      </a-form-model>
      <div class="drawer-btn">
        <a-button
          type="primary"
          @click="onSubmit"
          :style="{ marginRight: '8px' }"
        >
          确定
        </a-button>
        <a-button @click="onClose">
          取消
        </a-button>
      </div>
    </a-drawer>
  </div>
</template>
<script>
import {
  submitForm,
  drawerConfig,
  validator,
  changStatus,
  removeById,
  orderList
} from "../../../../utils/utils";
import API from "../api";
const columns = [
  {
    title: "图标名称",
    dataIndex: "name",
    ellipsis: true,
    key: "name",
    width: "20%"
  },
  {
    title: "图标类型",
    dataIndex: "type",
    ellipsis: true,
    key: "type",
    width: "20%",
    scopedSlots: { customRender: "type" }
  },
  {
    title: "所属分类",
    dataIndex: "icon_library_category_name",
    ellipsis: true,
    key: "icon_library_category_name",
    width: "20%"
  },
  {
    title: "添加时间",
    dataIndex: "create_time",
    ellipsis: true,
    key: "create_time",
    width: "20%"
  },
  {
    title: "操作",
    key: "action",
    width: "20%",
    scopedSlots: { customRender: "action" }
  }
];
export default {
  name: "iconList",
  data() {
    return {
      drawerConfig,
      pageNum: "",
      visiblebj: false,
      titleForm: "",
      editId: null,
      fieldId: null,
      pagination: {
        pageNo: 1,
        pageSize: 20, // 默认每页显示数量
        onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
        onChange: this.getList.bind(this), //点击页码事件
        total: 0, //总条数
        current: 0,
        size: "small",
        showTotal: (total) => `共 ${total} 条`,
        showQuickJumper: true
      },
      data: [],
      columns,
      loading: true,
      sortLists: [],
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      seach: {
        name: ""
      },
      formErr: {
        name: "",
        type: "",
        a_icon_library_category_id: "",
        font_class: "",
        unicode: "",
        unicode_decimal: ""
      },
      form: {
        name: "",
        type: "",
        a_icon_library_category_id: "",
        font_class: "",
        unicode: "",
        unicode_decimal: ""
      },
      typeList: [],
      icon_library_category: [],
      rules: {
        name: [
          { required: true, message: "请填写图标名称" },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.name);
            },
            trigger: "blur"
          }
        ],
        font_class: [
          { required: true, message: "请填写font_class字段" },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.font_class);
            },
            trigger: "blur"
          }
        ],
        unicode: [
          { required: true, message: "请填写unicode字段" },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.unicode);
            },
            trigger: "blur"
          }
        ],
        unicode_decimal: [
          { required: true, message: "请填写unicode_decimal字段" },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.unicode_decimal);
            },
            trigger: "blur"
          }
        ]
      },
      drawerTitle: "添加图标"
    };
  },

  components: {},

  mounted() {
    this.getList();
    this.getAdd();
  },
  methods: {
    onClose() {
      this.visiblebj = false;
      this.formErr = {
        name: "",
        type: "",
        a_icon_library_category_id: "",
        font_class: "",
        unicode: "",
        unicode_decimal: ""
      };
      this.form = {
        name: "",
        type: "",
        a_icon_library_category_id: "",
        font_class: "",
        unicode: "",
        unicode_decimal: ""
      };
    },
    getList(page) {
      this.pageNum = page;
      API.icon
        .GET_LIST({
          page: page || 1,
          ...this.seach
        })
        .then((res) => {
          this.pagination.total = res.data.data.list.total;
          this.pagination.pageSize = res.data.data.list.per_page;
          this.pagination.current = res.data.data.list.current_page;
          this.data = res.data.data.list.data;
          this.loading = false;
        });
    },
    resetSeach() {
      this.seach.name = "";
      this.getList(1);
    },
    getAdd() {
      API.icon.ADD().then((res) => {
        this.typeList = res.data.data.type;
        this.icon_library_category = res.data.data.icon_library_category;
      });
    },
    // 添加
    openAddModal() {
      this.getAdd()
      this.form = {
        name: "",
        type: 1,
        a_icon_library_category_id:
          this.icon_library_category.length > 0
            ? this.icon_library_category[0].id
            : "",
        font_class: "",
        unicode: "",
        unicode_decimal: ""
      };
      this.visiblebj = true;
      this.drawerTitle = "添加图标";
    },
    // 编辑
    getEditData() {
      this.getAdd()
      this.drawerTitle = "编辑图标";
      API.icon.EDIT(this.editId).then((res) => {
        this.form = res.data.data.info;
      });
    },
    onSubmit() {
      if (this.form["id"]) {
        this.editPost();
      } else {
        this.addPost();
      }
    },
    // 编辑提交
    editPost() {
      let _this = this;
      this.$refs.ruleform.validate((valid) => {
        if (valid) {
          submitForm(API.icon.EDIT_POST, _this.form).then((res) => {
            if (res == true) {
              this.onClose();
              this.getList(this.pageNum);
            } else {
              res.map((item, index) => {
                this.formErr[item.field] = item.msg;
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    addPost() {
      let _this = this;
      this.$refs.ruleform.validate((valid) => {
        if (valid) {
          submitForm(API.icon.ADD_POST, _this.form).then((res) => {
            if (res == true) {
              this.onClose();
              this.getList();
            } else {
              res.map((item, index) => {
                this.formErr[item.field] = item.msg;
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    confirm(row) {
      removeById(API.icon.DELE, [row.id]).then((res) => {
        if (res == true) {
          this.getList();
        }
      });
    }
  }
};
</script>

<style scoped>
.btntable {
  margin-right: 10px;
}
.inputs {
  display: inline-block;
  width: 70px;
}
.scroll-container {
  height: calc(100vh - 250px);
  overflow: auto;
}
.scroll-container::-webkit-scrollbar {
  width: 8px;
  background: white;
}
.scroll-container::-webkit-scrollbar-corner,
.scroll-container::-webkit-scrollbar-thumb,
.scroll-container::-webkit-scrollbar-track {
  border-radius: 4px;
}
.scroll-container::-webkit-scrollbar-corner,
.scroll-container::-webkit-scrollbar-track {
  background-color: #ddd;
  box-shadow: inset 0 0 1px #ddd;
}
.scroll-container::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
}
</style>
